module.exports = __webpack_public_path__ + "static/media/4.c54d6b47.jpg";